<template>
  <!-- 超出起订量弹窗 -->
  <Teleport to="body">
    <div class="exceed-order-quantity-dialog-wrapper">
      <div class="exceed-order-quantity-dialog">
        <img
          @click="handleClose"
          class="close"
          src="@/assets/images/close-icon.svg"
          alt=""
        >
        <img
          class="illus"
          src="@/assets/illus/over-buy-light.svg"
          alt=""
        >
        <div class="note">
          Please Note ...
        </div>
        <div class="desc">
          <div class="reason">
            As a B2B supplier, we recommend ordering {{ quantity * 2 }} samples to verify quality before bulk purchase.
          </div>
          <div
            @click="handleContactUs"
            class="contact-us"
          >
            Contact Us
          </div>
          <div
            @click="handleClose"
            class="got-it"
          >
            I Got It
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { useIntercom } from '@/hooks/useIntercom'

defineProps({
  quantity: {
    type: Number,
    default: 0
  }
})

const emits = defineEmits(['close'])

const { showNewMessage } = useIntercom()

const handleClose = () => {
  emits('close')
}

const handleContactUs = () => {
  showNewMessage()
}
</script>

<style lang='less' scoped>
.exceed-order-quantity-dialog-wrapper {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, .64);
  backdrop-filter: blur(8px);
  .exceed-order-quantity-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 329px;
    padding: 16px 24px 24px;
    background-color: white;
    border-radius: 8px;

    .close {
      position: absolute;
      top: 16px;
      right: 24px;
      cursor: pointer;
    }

    .note {
      color: #232323;
      margin-top: 16px;
      line-height: 20px;
      font-size: 16px;
      font-family: mon-600;
    }

    .desc {
      margin-top: 16px;
      .reason {
        font-size: 12px;
        font-family: mon-500;
        color: #232323;
        line-height: 16px;
        margin-bottom: 24px;
      }
      .contact-us, .got-it {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 44px;
        border-radius: 22px;
        background-color: #052784;
        color: white;
        font-size: 14px;
        font-family: mon-600;
      }
      .got-it {
        background-color: #f5f5f5;
        color: #232323;
        margin-top: 12px;
      }
    }
  }
}
</style>
